import React from "react";
import { Pressable, StyleSheet, View, ViewProps } from "react-native";

import { useIsMobile } from "src/hooks/ui";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { PdButton, PdButtonLabel, tPdButtonProps } from "src/components/v2/forms/button";
import { PdPencilSquare } from "src/components/Icons";

const WriteAnOrderButtonIcon: React.FC<ViewProps> = ({ style, ...rest }) => {
  return (
    <View style={[styles.writeOrderButtonIconContainer, style]} {...rest}>
      <PdPencilSquare color={kColors.white} style={styles.writeOrderButtonIcon} />
    </View>
  );
};

const WriteAnOrderButton: React.FC<tPdButtonProps> = ({ contentContainerStyle, ...rest }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Pressable {...rest}>
        <WriteAnOrderButtonIcon />
      </Pressable>
    );
  }

  return (
    <View>
      <PdButton
        size="lg"
        colorScheme="pink"
        contentContainerStyle={[styles.writeOrderButton, contentContainerStyle]}
        {...rest}
      >
        <WriteAnOrderButtonIcon style={styles.writeOrderButtonIconContainerWeb} />
        <PdButtonLabel>Write an Order</PdButtonLabel>
      </PdButton>
    </View>
  );
};

export default WriteAnOrderButton;

const styles = StyleSheet.create({
  writeOrderButton: {
    borderRadius: 999,
    paddingRight: kStyleConst.kSpacing * 8,
    right: 10,
  },
  writeOrderButtonIcon: {
    height: 20,
    marginLeft: 2,
    width: 20,
  },
  writeOrderButtonIconContainer: {
    alignItems: "center",
    backgroundColor: kColors.brand500,
    borderRadius: 999,
    height: 42,
    justifyContent: "center",
    width: 42,
  },
  writeOrderButtonIconContainerWeb: {
    position: "absolute",
    right: -10,
  },
});
